import React from 'react';
import { HeartHandshakeIcon, LayersIcon, MessagesSquareIcon, GlobeIcon } from 'lucide-react';
import { Reveal } from '../ui/Reveal';
const items = [{
  Icon: HeartHandshakeIcon,
  title: 'PERSONALIZED SERVICE',
  text: 'Atención enfocada en tus necesidades'
}, {
  Icon: LayersIcon,
  title: 'MULTIPLE OPTIONS',
  text: 'Trabajo con diferentes compañías'
}, {
  Icon: MessagesSquareIcon,
  title: 'CLEAR GUIDANCE',
  text: 'Explicaciones sencillas y transparentes'
}, {
  Icon: GlobeIcon,
  title: 'SPANISH SUPPORT',
  text: 'Atención personalizada en español'
}];
export function TrustBar() {
  return <section className="bg-white py-14 lg:py-16" aria-label="Credenciales" data-id="element-262" data-mp="2wev9yybbcku6">
      <div className="mx-auto grid max-w-shell grid-cols-1 gap-10 px-5 sm:grid-cols-2 lg:grid-cols-4 lg:gap-8 lg:px-10" data-id="element-263" data-mp="2rlabl55t5oug">
        {items.map(({
        Icon,
        title,
        text
      }, i) => <Reveal key={title} delay={i * 0.06} className="flex gap-4" data-id="element-264" data-mp="1yy69p920hqmw" data-mpi={i}>
            <Icon size={22} strokeWidth={1.25} className="mt-0.5 shrink-0 text-teal" data-id="element-265" data-mp="2rrj0d7ask72c" />
            <div data-id="element-266" data-mp="2rpokw8iah75n">
              <h3 className="font-display text-[12px] font-semibold tracking-[0.14em] text-navy" data-id="element-267" data-mp="2wqcd2xi97u1g">
                {title}
              </h3>
              <p className="mt-1.5 text-[13px] font-light leading-relaxed text-ink/60" data-id="element-268" data-mp="31iney5wk1pwn">
                {text}
              </p>
            </div>
          </Reveal>)}
      </div>
    </section>;
}